import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { containerTraversal } from "../../actionHelpers/containerTraversal";

export interface IBringToFrontContainerActionPayload {
  id: string;
  prevZIndex: number;
  nextZIndex: number;
}

export interface IBringToFrontContainerAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.BRING_TO_FRONT_CONTAINER;
  payload: IBringToFrontContainerActionPayload;
}

export function getBringToFrontContainerInverseAction(action: IBringToFrontContainerAction): IBringToFrontContainerAction {
  const { id, prevZIndex, nextZIndex } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.BRING_TO_FRONT_CONTAINER,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: action.scrollNodeId,
    payload: {
      id,
      prevZIndex: nextZIndex,
      nextZIndex: prevZIndex,
    },
  };
}

export function applyBringToFrontContainerChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: IBringToFrontContainerAction,
): IWebsiteBuilderHistorySnapshot {
  const { id, nextZIndex } = action.payload;

  return containerTraversal(header, root, footer, id, { zIndex: nextZIndex });
}
